export default class Pattern {
	static get(content, pattern, fallback) {
		if (typeof fallback == 'undefined')
			fallback = '';

		const match = content.match(pattern);
		return match ? match[1] : fallback;
	}

	static list(content, pattern) {
		return [...content.matchAll(pattern)];
	}
}